import DeviceMVPD from './DeviceMVPD';

export default DeviceMVPD;
